import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Switch from '@mui/material/Switch'

interface ToggleListItemProps {
  isChecked: boolean
  isDisabled?: boolean
  onToggle: () => void
  primaryText: string
  secondaryText?: string
  useExtraPadding?: boolean
}

export const ToggleListItem = ({
  isChecked,
  isDisabled = false,
  onToggle,
  primaryText,
  secondaryText = undefined,
  useExtraPadding = true,
}: ToggleListItemProps) => (
  <ListItem
    secondaryAction={<Switch checked={isChecked} disabled={isDisabled} onChange={onToggle} />}
    sx={{
      pl: useExtraPadding ? 48 : 0,
      '& .MuiListItemSecondaryAction-root': { right: useExtraPadding ? 64 : 24 },
    }}
  >
    <ListItemText
      primary={primaryText}
      secondary={secondaryText}
      slotProps={{
        primary: {
          fontWeight: 400,
          variant: 'body1',
          maxWidth: 'calc(100% - 60px)',
          color: 'text.primary',
        },
        secondary: {
          color: 'text.secondary',
          maxWidth: 'calc(100% - 60px)',
          variant: 'caption',
        },
      }}
    />
  </ListItem>
)
